//Paquetes NPM de GYF. 
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy, SagasHelper } from 'com-gyf-webcore-servicehub';

import DistribucionLimitesManager from '../../../Common/Managers/DistribucionLimitesManager';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

// ACTION TYPES
export const GET_SCREEN_DATA_DISTRIBUCION = 'GET_SCREEN_DATA_DISTRIBUCION';
export const GET_SCREEN_DATA_RESULTADO_DISTRIBUCION = 'GET_SCREEN_DATA_RESULTADO_DISTRIBUCION';
export const CHANGE_LIMITE = 'CHANGE_LIMITE';
export const SELECT_ADM = 'SELECT_ADM';
export const CANCELAR = 'CANCELAR';
export const SET_USER_FUNCTIONS_DISTRIBUCION = 'SET_USER_FUNCTIONS_DISTRIBUCION';
export const CAMBIAR_ESTADO_EDICION_EMPRESAS = 'CAMBIAR_ESTADO_EDICION_EMPRESAS';
export const CAMBIAR_ESTADO_EDICION_CUENTAS = 'CAMBIAR_ESTADO_EDICION_CUENTAS';
export const CAMBIAR_ESTADO_EDICION_TARJETAS = 'CAMBIAR_ESTADO_EDICION_TARJETAS';
export const CLOSE_MODAL_ESTA_EDITANDO = 'CLOSE_MODAL_ESTA_EDITANDO';
export const OPEN_MODAL_ESTA_EDITANDO = 'OPEN_MODAL_ESTA_EDITANDO';
export const GUARDAR_DISTRIBUCION_LIMITES = 'GUARDAR_DISTRIBUCION_LIMITES';
export const GUARDAR = 'GUARDAR';
export const SHOW_SAVE_STATUS_LIMITES = 'SHOW_SAVE_STATUS_LIMITES';
export const READY_REQUEST_LIMITES = 'READY_REQUEST_LIMITES';
export const OBTENER_LIMITE_CUENTA_POR_PRODUCTO = 'OBTENER_LIMITE_CUENTA_POR_PRODUCTO';
export const RENDER_RANDOM = 'RENDER_RANDOM';

let _cliente, _storeTarjetas, _getDatosFromDB, _executionContext;
let _dispatch = null;

/**
 * Action que obtiene el estado inicial.
 * @param {any} currentScope
 */
export function getScreenData(currentScope, cliente, storeTarjetas, getDatosFromDB, sesion) {
    LogHelper.In(getScreenData.name, currentScope, cliente, storeTarjetas, getDatosFromDB, sesion);

    _cliente = cliente;
    return (dispatch, getState) => {
        _dispatch = dispatch;
        _storeTarjetas = storeTarjetas;
        _getDatosFromDB = getDatosFromDB;
        _executionContext = sesion.executionContext;
        
        dispatch({ type: GET_SCREEN_DATA_DISTRIBUCION });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadUserFunctions(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

/**
 * Modifica el valor de limite.
 * @param {any} id
 */
export function changeLimite(id) {
    LogHelper.In(changeLimite.name, id);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let estado = getState();

        if (!estado.distribucionLimites.seEstaEditando) {
            dispatch({
                type: CHANGE_LIMITE,
                valueId: id
            });
        }
        else {
            return dispatch({ type: OPEN_MODAL_ESTA_EDITANDO });
        }
    }
}

/**
 * Selecciona una nueva administradora.
 * @param {any} id
 */
export function selectAdministradora(id) {
    LogHelper.In(selectAdministradora.name, id);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({
            type: SELECT_ADM,
            valueId: id
        });
    }
}

/**
 * Guarda los cambios realizados en distribución de limites.
 * @param {any} cerrarmodal
 */
export function guardar(cerrarmodal, guardaBBDD) {
    LogHelper.In(guardar.name, cerrarmodal, guardaBBDD);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let estado = getState();

        if (!estado.distribucionLimites.seEstaEditando) {
            if (guardaBBDD) {
                //Proceso de guardar en la BD
                DistribucionLimitesManager.GuardarLimites(estado.distribucionLimites, SagasHelper.GetSagasId, (result) => ejecutarPorEstado(result, cerrarmodal), _executionContext, estado.tarjetas.novedadesCampoLimites);
                dispatch({ type: READY_REQUEST_LIMITES });
                for (var e = 0; e < estado.distribucionLimites.novedadesEmpresas.length; e++) {
                    estado.distribucionLimites.novedadesEmpresas[e].NovedadCampoCodigo = "LIMCO_EMPR";
                }
                for (var c = 0; c < estado.distribucionLimites.novedadesCuentas.length; c++) {
                    estado.distribucionLimites.novedadesCuentas[c].NovedadCampoCodigo = "LIMCO_CUEN";
                }
                for (var t = 0; t < estado.distribucionLimites.novedadesTarjetas.length; t++) {
                    estado.distribucionLimites.novedadesTarjetas[t].NovedadCampoCodigo = "LIMCO_TARJ";
                }
                dispatch({
                    type: 'ACTUALIZAR_LIMITES_VISTA_CLIENTE', estado: {
                        novedadesEmpresas: estado.distribucionLimites.novedadesEmpresas,
                        novedadesCuentas: estado.distribucionLimites.novedadesCuentas,
                        novedadesTarjetas: estado.distribucionLimites.novedadesTarjetas,
                        empresas: estado.vistaCliente.data.enterprises,
                        cuentas: estado.distribucionLimites.cuentas,
                        tarjetas: estado.distribucionLimites.tarjetas,
                        empresasNoModificadas: estado.distribucionLimites.empresasNoModificadas,
                        cuentasNoModificadas: estado.distribucionLimites.cuentasNoModificadas,
                        tarjetasNoModificadas: estado.distribucionLimites.tarjetasNoModificadas
                    }
                });
            }
            else {
                //Proceso de no guardar en la BD
                let resultadoDistribucionLimites = {
                    empresas: estado.distribucionLimites.empresas,
                    cuentas: estado.distribucionLimites.cuentas,
                    tarjetas: estado.distribucionLimites.tarjetas,
                    novedadesEmpresas: estado.distribucionLimites.novedadesEmpresas,
                    novedadesCuentas: estado.distribucionLimites.novedadesCuentas,
                    novedadesTarjetas: estado.distribucionLimites.novedadesTarjetas
                }

                cerrarmodal();
                return dispatch({ type: GUARDAR_DISTRIBUCION_LIMITES, resultadoDistribucionLimites: resultadoDistribucionLimites });
            }
        }
        else {
            return dispatch({ type: OPEN_MODAL_ESTA_EDITANDO });
        }
    }
}

/**
 * Cancela los cambios realizados en distribución de limites y cierra el modal.
 * @param {any} cerrarmodal
 */
export function cancelar(cerrarmodal) {
    LogHelper.In(cancelar.name, cerrarmodal);

    return (dispatch, getState) => {
        let estado = getState();

        if (!estado.distribucionLimites.seEstaEditando) {
            _dispatch = dispatch;
            dispatch({
                type: CANCELAR
            });

            cerrarmodal();
        } else {
            return dispatch({ type: OPEN_MODAL_ESTA_EDITANDO });
        }
    }
}

/**
 * Permite a las pantallas hijas (empresas) modificar el estado del padre.
 * @param {any} estado
 */
export function cambiarEstadoEdicionEmpresa(estado) {
    LogHelper.In(cambiarEstadoEdicionEmpresa.name, estado);
    
    return (dispatch, getState) => {
        const { clienteResultadoBusqueda } = getState().tarjetas;
        const { empresas, novedadesEmpresas } = estado;
        let cliente = clienteResultadoBusqueda;
        return dispatch({ type: CAMBIAR_ESTADO_EDICION_EMPRESAS, data: { ...estado, cliente } });
    }
}

/**
 * Permite a las pantallas hijas (cuentas) modificar el estado del padre.
 * @param {any} estado
 */
export function cambiarEstadoEdicionCuenta(estado) {
    LogHelper.In(cambiarEstadoEdicionCuenta.name, estado);
    
    return (dispatch, getState) => {
        const { clienteResultadoBusqueda } = getState().tarjetas;
        const { cuentas, novedadesCuentas } = estado;
        let cliente = clienteResultadoBusqueda;
        return dispatch({ type: CAMBIAR_ESTADO_EDICION_CUENTAS, data: { ...estado, cliente } });
    }
}

/**
 * Permite a las pantallas hijas (cuentas) modificar el estado del padre y obtiene los limites de compra por producto de la cuenta.
 * @param {any} estado
 */
export function obtenerLimiteCuentaPorProducto(estado, id) {
    LogHelper.In(obtenerLimiteCuentaPorProducto.name, estado, id);
    
    return (dispatch, getState) => {
        _dispatch = dispatch;
        const { clienteResultadoBusqueda } = getState().tarjetas;
        const cliente = clienteResultadoBusqueda;
        let cuenta = estado.cuentas.find(x => x.Id == id);
        const paramProducto = { "PRODUCTO_ID": parseInt(cuenta.ProductoId) }
        LogHelper.Out(_loadScreenData.name, paramProducto, 'GET_PRODUCTO_LIMITE_COMPRA_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramProducto, 'GET_PRODUCTO_LIMITE_COMPRA_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');

        Engine1Proxy.Execute((data) => _obtenerLimiteCuentaPorProducto(data, estado, getState), null, null, "CONSULTASOCIOS");
    }
}

/**
 * Permite a las pantallas hijas (tarjetas) modificar el estado del padre.
 * @param {any} estado
 */
export function cambiarEstadoEdicionTarjeta(estado) {
    LogHelper.In(cambiarEstadoEdicionTarjeta.name, estado);

    return (dispatch, getState) => {
        const { clienteResultadoBusqueda } = getState().tarjetas;
        const { tarjetas, novedadesTarjetas } = estado;
        let cliente = clienteResultadoBusqueda;

        return dispatch({ type: CAMBIAR_ESTADO_EDICION_TARJETAS, data: { ...estado, cliente } });
    }
}

/**
 * No cierra el modal si esta editando
 */
export function closeModalEstaEditando() {
    LogHelper.In(closeModalEstaEditando.name);

    return (dispatch, getState) => {
        return dispatch({ type: CLOSE_MODAL_ESTA_EDITANDO });
    }
}

/*-----------------------------------------FUNCIONES AUXILIARES-----------------------------------------*/
/**
 * Permite a las pantallas hijas (cuentas) modificar el estado del padre.
 * @param {any} estado
 */
function _cambiarEstadoEdicionCuenta(estado, getState) {
    LogHelper.In(_cambiarEstadoEdicionCuenta.name, estado, getState);

    const { clienteResultadoBusqueda } = getState().tarjetas;
    const { cuentas, novedadesCuentas } = estado;
    const cliente = clienteResultadoBusqueda;

    _dispatch({ type: CAMBIAR_ESTADO_EDICION_CUENTAS, data: { ...estado, cliente } });
    _dispatch({ type: RENDER_RANDOM });
}

/**
 * Funcion callback que establece los permisos que tiene el usuario sobre la pantalla y/o componentes
 * @param { any } data Parametro injectado desde la funcion callback, contiene un string de los permisos del usuario
 */
function _loadUserFunctions(data) {
    LogHelper.In(_loadUserFunctions.name, data);

    let functions = data.CONSULTASOCIOS;
    let functionsAllowed = {}

    functions.forEach(p => { functionsAllowed[p.Codigo_Funcion] = true; });
    _dispatch({ type: SET_USER_FUNCTIONS_DISTRIBUCION, functions: functionsAllowed });

    _loadScreenData();
}

/**
 * 
 * @param {any} data
 * @param {any} estado
 * @param {any} getState
 */
function _obtenerLimiteCuentaPorProducto(data, estado, getState) {
    LogHelper.In(_obtenerLimiteCuentaPorProducto.name, data, estado, getState);
    
    let limiteCompra = JSON.parse(data.GET_PRODUCTO_LIMITE_COMPRA_PRODUCTO_ID).Recordset0.Rows;

    _dispatch({ type: OBTENER_LIMITE_CUENTA_POR_PRODUCTO, limiteCompra: limiteCompra });
    _cambiarEstadoEdicionCuenta(estado, getState);
}

/**
 * 
 */
function _loadScreenData() {
    LogHelper.In(_loadScreenData.name);

    //Carga toda la informacion necesaria para limites...

    let cuit = _cliente.cuit == undefined ? _cliente.Cuit : _cliente.cuit

    let parametro = { 'CUIT': parseInt(cuit.replace("-","")) }
    let administradoraId = { 'ADMINISTRADORA_ID': 1 }

  

    LogHelper.Out(_loadScreenData.name, administradoraId, 'GET_LIMITE_COMPRA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(administradoraId, 'GET_LIMITE_COMPRA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_loadScreenData.name, null, 'GET_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_loadScreenData.name, parametro, 'GET_CLIENTE_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_CLIENTE_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');

    if (_getDatosFromDB) {
        LogHelper.Out(_loadScreenData.name, parametro, 'GET_EMPRESA_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_EMPRESA_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        LogHelper.Out(_loadScreenData.name, parametro, 'GET_CUENTA_TARJETA_BY_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_CUENTA_TARJETA_BY_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        LogHelper.Out(_loadScreenData.name, parametro, 'GET_CUENTA_TARJETA_VISA_BY_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_CUENTA_TARJETA_VISA_BY_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        LogHelper.Out(_loadScreenData.name, parametro, 'GET_NOVEDADES_EMPRESA_BY_CUIT', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_NOVEDADES_EMPRESA_BY_CUIT', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
        LogHelper.Out(_loadScreenData.name, parametro, 'GET_NOVEDADES_CUENTA_TARJETA_BY_CUIT', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_NOVEDADES_CUENTA_TARJETA_BY_CUIT', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
        LogHelper.Out(_loadScreenData.name, parametro, 'GET_NOVEDADES_TARJETA_BY_CUIT', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_NOVEDADES_TARJETA_BY_CUIT', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
    }

    Engine1Proxy.Execute(_loadPermisosByUsuario, null, null, "CONSULTASOCIOS");
}

/**
 * Carga inicial de los store procedure obtenidos de la base de datos
 * @param {any} data
 */
function _loadPermisosByUsuario(data) {
    LogHelper.In(_loadPermisosByUsuario.name, data);

    let tarjetas, cuentas
    if (_getDatosFromDB) {
        let tarjetasVisa = JSON.parse(data.GET_CUENTA_TARJETA_VISA_BY_CUIT).Recordset1.Rows;
        let cuentasTarjetasVisa = JSON.parse(data.GET_CUENTA_TARJETA_VISA_BY_CUIT).Recordset0.Rows;

        tarjetas = JSON.parse(data.GET_CUENTA_TARJETA_BY_CUIT).Recordset1.Rows.map((tc) => {
            return Object.assign({}, tc, tarjetasVisa.find((tcv) => tcv.TarjetaCreditoId == tc.Id));
        });

        cuentas = JSON.parse(data.GET_CUENTA_TARJETA_BY_CUIT).Recordset0.Rows.map((ct) => {
            ct.CantTarjetasCredito = tarjetas.filter((te) => te.CuentaTarjetaId == ct.Id).length;
            return Object.assign({}, ct, cuentasTarjetasVisa.find((ctv) => ctv.CuentaTarjetaId == ct.Id));
        });
    }
    
    let resultado = {
        'limiteCompra': JSON.parse(data.GET_LIMITE_COMPRA).Recordset0.Rows,
        'administradoras': JSON.parse(data.GET_ADMINISTRADORA).Recordset0.Rows,
        'empresas': _getDatosFromDB ? JSON.parse(data.GET_EMPRESA_CUIT).Recordset0.Rows : JSON.parse(JSON.stringify(_storeTarjetas.empresas)),
        'cuentas': _getDatosFromDB ? cuentas : JSON.parse(JSON.stringify(_storeTarjetas.cuentas)),
        'tarjetas': _getDatosFromDB ? tarjetas : JSON.parse(JSON.stringify(_storeTarjetas.tarjetas)),
        'empresasNoModificadas': _getDatosFromDB ? JSON.parse(data.GET_EMPRESA_CUIT).Recordset0.Rows : JSON.parse(JSON.stringify(_storeTarjetas.empresas)),
        'cuentasNoModificadas': _getDatosFromDB ? JSON.parse(data.GET_CUENTA_TARJETA_BY_CUIT).Recordset0.Rows : JSON.parse(JSON.stringify(_storeTarjetas.cuentas)),
        'tarjetasNoModificadas': _getDatosFromDB ? tarjetas : JSON.parse(JSON.stringify(_storeTarjetas.tarjetas)),
        'novedadesEmpresas': _getDatosFromDB ? JSON.parse(data.GET_NOVEDADES_EMPRESA_BY_CUIT).Recordset0.Rows : JSON.parse(JSON.stringify(_storeTarjetas.novedadesEmpresas)),
        'novedadesCuentas': _getDatosFromDB ? JSON.parse(data.GET_NOVEDADES_CUENTA_TARJETA_BY_CUIT).Recordset0.Rows : _storeTarjetas.novedadesCuentas ? JSON.parse(JSON.stringify(_storeTarjetas.novedadesCuentas)):[],
        'novedadesTarjetas': _getDatosFromDB ? JSON.parse(data.GET_NOVEDADES_TARJETA_BY_CUIT).Recordset0.Rows : _storeTarjetas.novedadesTarjetas ? JSON.parse(JSON.stringify(_storeTarjetas.novedadesTarjetas)):[],
        'datosCliente': JSON.parse(data.GET_CLIENTE_CUIT).Recordset0.Rows
    }

    resultado.tarjetaOriginal = JSON.parse(JSON.stringify(resultado.tarjetas));

    let limiteCliente = _cliente.Limite != undefined ? _cliente.Limite : 0;
    let administradoraSeleccionadaId = 1;
    let paginaInicial = _storeTarjetas.seleccionDistribucionLimite != undefined ? _storeTarjetas.seleccionDistribucionLimite : 0
    
    _dispatch({
        type: GET_SCREEN_DATA_RESULTADO_DISTRIBUCION,
        resultado: resultado,
        paginaInicial: paginaInicial,
        limiteCliente: limiteCliente,
        administradoraSeleccionadaId: administradoraSeleccionadaId
    });
}

/**
 * 
 * @param {any} result
 * @param {any} cerrarmodal
 */
function ejecutarPorEstado(result, cerrarmodal) {
    LogHelper.In(ejecutarPorEstado.name, result, cerrarmodal);

    let type;
    let modalId;

    cerrarmodal();
    _dispatch({ type: SHOW_SAVE_STATUS_LIMITES });
}


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Screens/DistribucionLimites/actions/DistribucionLimitesActions.js